'use client';

import { overlay } from 'overlay-kit';
import AppInstallModal from '@/app/cc/_component/ui/modal/AppInstallModal/AppInstallModal';
import { APPINSTALL_URL } from '@/app/cc/_consts/APPINSTALL_URL';
const TOWN_WEB_URL = process.env.NEXT_PUBLIC_TOWN_WEB_URL ?? 'https://dtown.aipartner.com';
export default function useOpenAppInstall({
  type = 'town',
  deviceType,
  clientInfo,
  agencyNo
}: {
  readonly type: 'town' | 'realtor';
  readonly deviceType: string | null | undefined;
  readonly clientInfo: string | null | undefined;
  readonly agencyNo?: number;
}) {
  return () => {
    if (type === 'town') {
      if (deviceType === 'mobile') {
        if (clientInfo?.includes('Android')) {
          window.open(APPINSTALL_URL.DOWNLOAD_URL.android, '_blank', 'noopener,noreferrer');
          return;
        }
        if (clientInfo?.includes('iOS')) {
          window.open(APPINSTALL_URL.DOWNLOAD_URL.ios, '_blank', 'noopener,noreferrer');
          return;
        }
        window.open(APPINSTALL_URL.DOWNLOAD_URL.android, '_blank', 'noopener,noreferrer');
        return;
      }
    }
    if (type === 'realtor') {
      if (deviceType === 'mobile') {
        window.open(`${TOWN_WEB_URL}/app/realtor/${agencyNo}`, '_blank', 'noopener,noreferrer');
        return;
      }
    }
    overlay.open(({
      isOpen,
      close
    }) => <AppInstallModal isOpen={isOpen} onClose={close} />);
  };
}